import { render, staticRenderFns } from "./TikTokAddUnauthorisedProfileDialog.vue?vue&type=template&id=067e4c22&scoped=true"
import script from "./TikTokAddUnauthorisedProfileDialog.vue?vue&type=script&lang=js"
export * from "./TikTokAddUnauthorisedProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./TikTokAddUnauthorisedProfileDialog.vue?vue&type=style&index=0&id=067e4c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e4c22",
  null
  
)

export default component.exports